import { useState } from "react";
import { Gift, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function ThankReferrerButton({ api, leader, index, onIssued }) {
  const [open, setOpen] = useState(false);
  const [pct, setPct] = useState("20");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    const n = parseInt(pct, 10);
    if (!(n >= 1 && n <= 90)) {
      toast.error("Discount must be 1–90%.");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/referral-leaderboard/${leader.user_id}/thank`, { pct: n });
      onIssued(leader.user_id, data);
      setOpen(false);
      if (data.emailed) toast.success(`Code ${data.code} emailed to ${leader.email}`);
      else toast.warning(`Code ${data.code} created, but the email didn't send. Share it with them directly.`);
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not issue the code.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={`leader-thank-btn-${index}`} className="min-h-[40px] px-3 border border-[#FFD600] text-[#FFD600] hover:bg-[#FFD600] hover:text-black font-mono-label text-[11px] inline-flex items-center gap-2 transition-colors shrink-0">
          <Gift size={13} /> Send thank-you code
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 bg-[#0A0A0A] border-[#262626]" data-testid={`leader-thank-popover-${index}`}>
        <label className="text-xs text-muted-foreground">One-time discount (%)
          <input type="number" min={1} max={90} value={pct} onChange={(e) => setPct(e.target.value)} data-testid={`leader-thank-pct-${index}`}
            className="block mt-1 h-10 w-full px-3 bg-[#141414] border border-[#262626] text-white text-sm" />
        </label>
        <p className="text-[11px] text-muted-foreground mt-2">Works once, only for this client, on their next payment. We email it to them. Any unused earlier code is replaced.</p>
        <button onClick={send} disabled={busy} data-testid={`leader-thank-send-${index}`}
          className="mt-3 h-10 w-full cta-primary font-mono-label text-[11px] inline-flex items-center justify-center gap-2 disabled:opacity-60">
          {busy && <Loader2 size={13} className="animate-spin" />} Email code
        </button>
      </PopoverContent>
    </Popover>
  );
}
